var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PageTemplate", {
    scopedSlots: _vm._u([
      {
        key: "page-content",
        fn: function () {
          return [
            _c("b-container", { attrs: { fluid: "", id: "page-container" } }, [
              _c("div", { attrs: { id: "content-container-with-border" } }, [
                _c("h1", [_vm._v("PayPoint Privacy Statement")]),
                _vm._v(" "),
                _c("h1", [_vm._v("When is information collected?")]),
                _vm._v(
                  '\n        This Privacy Statement tells you what to expect when the PayPoint\n        Group ("PayPoint") collects personal information. It applies to\n        information we collect about:\n        '
                ),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "PayPoint Retailers providing services to PayPoint."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            PayPoint Agents using PayPoint Retailer Services (e.g. EPOS).\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Visitors to our websites.")]),
                ]),
                _vm._v(
                  "\n        It is intended to give you a better understanding of the data we use\n        and what we do with your data.\n\n        "
                ),
                _c("h1", [_vm._v("Definitions")]),
                _vm._v(" "),
                _c("p", [_vm._v("For the purpose of this Privacy Notice;")]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Client")]),
                  _vm._v(
                    " means an organisation using a PayPoint\n          service to obtain payment from or make payments to a consumer or\n          business.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Customer")]),
                  _vm._v(
                    " means a consumer or business that is a\n          customer of a client.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("PayPoint")]),
                  _vm._v(
                    " means a member of the PayPoint Group.\n          Members of the PayPoint Group are listed on the website under\n          PayPoint Companies Regulatory Information.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p"),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("PayPoint Retailer")]),
                  _vm._v(
                    " means an organisation providing\n          services to PayPoint.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p"),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("PayPoint Agent")]),
                  _vm._v(
                    " means an individual or organisation\n          using a PayPoint Retailer Service, such as card processing or EPOS.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Transaction Data")]),
                  _vm._v(
                    " means information in relation to\n          the transaction processed by PayPoint.\n        "
                  ),
                ]),
                _vm._v(
                  '\n        References to "personal data" and "data subject" shall have the\n        meaning assigned to them in the Data Protection Act 2018.\n\n        '
                ),
                _c("h1", [
                  _vm._v("On what basis will we use your information?"),
                ]),
                _vm._v(
                  "\n        We will only use your information where we have your consent or we\n        have another lawful reason for using it. These reasons include where\n        we:\n        "
                ),
                _c("ul", [
                  _c("li", [
                    _vm._v("need to pursue our legitimate interests;"),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            need to process the information to carry out an agreement we have\n            with you;\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            need to process the information to comply with a legal obligation;\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            believe the use of your information as described is in the public\n            interest, e.g. for the purpose of preventing or detecting crime;\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            need to establish, exercise or defend our legal rights; or\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "need to use your information for our insurance purposes."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("Disclosure of personal information")]),
                _vm._v(
                  "\n        We may from time to time disclose information as follows;\n        "
                ),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n            Your personal data to appropriate investigatory and regulatory\n            authorities.\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            Your information to a supplier if required to use a PayPoint\n            service, provide a service to PayPoint or obtain support for\n            PayPoint services.\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            If you have provided your business information such as name,\n            contact name, location, contact number we may give this together\n            with details of individual transactions to clients and customer of\n            clients in relation to questions or queries in associated with the\n            PayPoint services.\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            If you use PayPoint Retailer Services, we may give your business\n            information to third parties such as acquirers or your EPOS\n            wholesalers if you use our services.\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            If you are a payment agent we may provide your personal data to\n            the Financial Conduct Authority as part of the payment agent\n            accreditation process and maintenance of the appropriate\n            registrations.\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            If you are a customer of a client we may provide your information\n            to your service provider (the client) and the appropriate\n            authorities.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("Monitoring")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          PayPoint electronic communication systems are monitored without user\n          consent to: investigate or detect unauthorised use; prevent or\n          detect crime; establish the existence of facts relevant to PayPoint;\n          or ascertain compliance with regulatory practices relevant to the\n          business of PayPoint.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          Calls to PayPoint are recorded for operational and training\n          purposes. Calls are not processed against the individual data\n          subject.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("PayPoint Retailer Information")]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Validation")]),
                  _vm._v(
                    " - In order to provide services to\n          PayPoint, a PayPoint Retailer is required to provide personal data\n          to PayPoint. PayPoint will need to maintain this information to\n          verify the identity of the PayPoint Retailer and make certain\n          checks. We may verify your information by using verification and\n          identity checking services such as Experian or Creditsafe. PayPoint\n          may also be required to disclose this information to the appropriate\n          regulatory authorities. As a PayPoint Retailer your details will\n          also appear as a payment agent on the Financial Conduct Authority\n          register.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          PayPoint may use this personal data to perform checks and obtain\n          reports in relation to the PayPoint Retailer. This may include\n          credit checks as specified in the PayPoint Retailer consent form\n          previously provided to you.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("My Payment")]),
                  _vm._v(
                    " - A copy of the current version of the\n          consent form is available on My PayPoint. Further information in\n          relation to the use of PayPoint Retailer information is available in\n          the Privacy FAQs – PayPoint Retailer available on My PayPoint. You\n          can set your own preferences for disclosure to your employees of\n          your business information accessible by using the settings available\n          on MyPayPoint.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Disclosures")]),
                  _vm._v(
                    " - We may disclose information you\n          supply to regulatory bodies, investigatory authorities such as the\n          police, HMRC, your acquirer (if you use our card services) and\n          public health authorities. We may also disclose your information to\n          provide you with operational support for products and/or services\n          such as maintenance call outs or your bank details to our payment\n          service providers so you can make and receive payments from us.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("PayPoint Group offers")]),
                  _vm._v(
                    " - We may use your information\n          to provide you with details of products or services provided by the\n          PayPoint Group relevant to your business.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Third party offers")]),
                  _vm._v(
                    " - From time to time we give you\n          the opportunity to participate in offers and services provided by\n          third parties. If you decide to participate you will contract on the\n          third-party terms but we may disclose your information to the third\n          party to enable them to offer their services to you. We may need to\n          provide such third parties with information when you change, amend\n          or update your personal details and/or your services with PayPoint\n          as it may impact the terms they offer. You should review any\n          third-party terms to make sure they are suitable for your needs.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Regulatory and Compliance")]),
                  _vm._v(
                    " - We are required to\n          process your personal data in order for you to provide services to\n          us and for us to provide services to you under the terms of your\n          agreements with us. For regulatory and compliance purposes we are\n          not able to automatically delete data that relates to payment\n          transactions processed by you or accreditation information provided\n          by you.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Service updates")]),
                  _vm._v(
                    " - We will use information provided\n          by you to provide you with service updates and information to enable\n          you to provide services to us or for us to provide services to you.\n          We request you provide us with your business e-mail address or\n          business contact details for these communications.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("COVID 19")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          During the COVID 19 pandemic we may ask you for information as to\n          whether your outlet or premises have been impacted by the need of\n          individuals to isolate or otherwise take action in relation to COVID\n          19.\n          "
                  ),
                  _c("strong", [
                    _vm._v(
                      "We do not require you to give us any information in relation to\n            individuals."
                    ),
                  ]),
                  _vm._v(
                    "\n          But we do request you contact us if our representatives have been in\n          contact with someone who is subsequently required to isolate or your\n          business needs to temporarily suspend services to comply with COVID\n          19 guidelines. Any such information is recorded against the site\n          reference but not against individuals\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Marketing to a PayPoint Retailer")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          PayPoint may use PayPoint Retailer contact information to provide\n          services to, market to or enhance services to the PayPoint Retailer.\n          You may elect to have marketing services in different forms such as\n          text or email or via social media contact groups via the Preference\n          Centre.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          PayPoint does not provide your information to third parties for\n          marketing purposes without your consent.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you have agreed, PayPoint may from time to time share the\n          PayPoint Retailer contact information with third parties to offer\n          services to the PayPoint Retailer. If a PayPoint Retailer contact\n          does not wish to receive such communications they can unsubscribe\n          using the link at the bottom of email or make changes via the\n          Preference Centre.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("Data export or transfer")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    '\n          In order to provide services or support to Clients, PayPoint\n          Retailers and consumers PayPoint may use service providers\n          implementing "cloud" based and other technology. These services may\n          include operational, technical and administrative support that is\n          based outside the EEA. Any transfer of personal data that is outside\n          the EEA will be in accordance with the recommended data transfer\n          models applicable at the time.\n        '
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("PayPoint Agents")]),
                _vm._v(" "),
                _c("h2", [_vm._v("EPoS Services")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          All personal data submitted by the PayPoint Retailer or PayPoint\n          Agent in relation to their use of the PayPoint EPoS Services is\n          confidential and controlled by the PayPoint Retailer or PayPoint\n          Agent. PayPoint Retailers and PayPoint Agents have full ownership of\n          and access to all their own trading data. In common with other EPoS\n          providers, PayPoint retains the right to use trading data from\n          PayPoint Retailers' and PayPoint Agents' use of the system and\n          services for product improvements, management information, data\n          aggregation and business development purposes.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Debit and credit card services")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you use our debit and credit card services we may disclose your\n          personal data associated with that service such as your contact\n          details to your acquirer or if so requested to the payment card\n          schemes such as MasterCard Inc or Visa Europe Limited.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("My.PayPoint.com")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          My.PayPoint.com provides PayPoint Retailers and PayPoint Agents with\n          access to information about the services we provide to you and you\n          provide to us, including information on sales performance and\n          financial calculations.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          By authorising and providing access of the My.PayPoint.com website\n          to other users in connection with your business, you confirm the\n          users have consented to the PayPoint Privacy Statement.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          In order to provide the My.PayPoint.com services, PayPoint will use\n          the data submitted to us by the PayPoint Agent and/or PayPoint\n          Retailer in relation to the PayPoint services, including any trading\n          data. PayPoint Agents have full ownership of and access to all their\n          own trading data. PayPoint retains the right to use trading data\n          from PayPoint Retailers’ and PayPoint Agents’s use of the system and\n          services for product improvements, management information, data\n          aggregation and business development purposes.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("Complaints or queries")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          PayPoint applies transparency when collecting and using personal\n          information. We have prepared as series of FAQs to enable you to\n          understand how we use your data. If you have concerns over the use\n          of your personal data please contact us.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          This Privacy Statement and any Privacy FAQs are not an exhaustive\n          list of all aspects of PayPoint’s collection and use of personal\n          information. If you wish to have any additional information or\n          explanation please contact us via the contact details set out below\n          or your normal contact.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you want to request information about our privacy policies or a\n          complaint you can e-mail us at\n          "
                  ),
                  _c("a", { attrs: { href: "mailto:privacy@paypoint.com" } }, [
                    _vm._v("privacy@paypoint.com"),
                  ]),
                  _vm._v(" or\n          write to us at:\n        "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n          Data Protection Officer"),
                  _c("br"),
                  _vm._v("PayPoint Group"),
                  _c("br"),
                  _vm._v("1 The Boulevard"),
                  _c("br"),
                  _vm._v("Shire\n          Park"),
                  _c("br"),
                  _vm._v("Welwyn Garden City"),
                  _c("br"),
                  _vm._v("Hertfordshire"),
                  _c("br"),
                  _vm._v("AL7 1EL\n        "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you have a complaint in relation to the use of your personal data\n          you may contact us in the first instance. If you are still not happy\n          we have resolved the matter you may also contact the Information\n          Commissioner’s Office. Contact details are available on the\n          Information Commissioner’s website.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("Access requests")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    '\n          Individuals can find out if we hold any personal information by\n          making a "subject access request" under the Data Protection Act\n          2018. If we do hold information about you we will:\n        '
                  ),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [_vm._v("give you a description of it;")]),
                  _vm._v(" "),
                  _c("li", [_vm._v("tell you why we are holding it;")]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("tell you who it could be disclosed to; and"),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n            let you have a copy of the information in an intelligible form.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          To make a request to PayPoint for any personal information we may\n          hold, you need to put the request in writing addressing it to our\n          Data Protection Officer at the address provided below. We cannot\n          disclose information in relation to other data subjects, client\n          information or client customer information under such a request. We\n          will remove information relating to other data subject or other\n          organisation from the information we send you.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you agree, we will try to deal with your request informally, for\n          example by providing you with the specific information you need over\n          the telephone. If you have e-mailed us we will respond by e-mail.\n          Please note e-mail communications are no guaranteed to be secure due\n          to the nature of the communication method.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          The Information Commissioner has provided a guide on its website to\n          data subject access requests. This provides indications of the\n          circumstances when an access request can be limited or declined. For\n          example, a data subject access request does not entitle the data\n          subject to information relating to or confidential to a third party.\n          Data subject access requests are available to individuals but not\n          businesses.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Other use of your rights")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          Under the Data Protection Act 2018, you have rights as an individual\n          which you can exercise in relation to the information we hold about\n          you. You can read more about these rights here –\n          "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://ico.org.uk/for-the-public/is-my-information-being-handled-correctly/",
                      },
                    },
                    [
                      _vm._v(
                        "https://ico.org.uk/for-the-public/is-my-information-being-handled-correctly/"
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("General")]),
                _vm._v(" "),
                _c("h2", [_vm._v("People who e-mail us")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          Any e-mail sent to us, including any attachments, may be monitored\n          and used by us for reasons of security and for monitoring compliance\n          with PayPoint policies. E-mail monitoring or blocking software may\n          also be used. Please be aware that you have a responsibility to\n          ensure that any e-mail you send to us is within the bounds of the\n          law.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("People who call our call centre")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          When you call the PayPoint’s call centre we may collect caller\n          identification information. We use this information to help improve\n          its efficiency and effectiveness. We may record your call to us for\n          operational and training purposes. Recordings of any such calls is\n          not retained against or save to the name of the individual caller.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Visitors to our websites")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n          When you visit our websites\n          "),
                  _c("a", { attrs: { href: "https://my.paypoint.com" } }, [
                    _vm._v("my.paypoint.com"),
                  ]),
                  _vm._v(" and\n          "),
                  _c("a", { attrs: { href: "https://www.paypoint.com" } }, [
                    _vm._v("www.paypoint.com"),
                  ]),
                  _vm._v(
                    " please see\n          the relevant website privacy notice for details of cookies and other\n          information specific to the website.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Links to other websites")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          This Privacy Notice does not cover the links within any PayPoint\n          website or documentation linking to other websites. We encourage you\n          to read the privacy statements on any other websites you visit.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Changes to this privacy notice")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          We keep our privacy notice under regular review so please check for\n          notices of changes on My PayPoint or in our newsletters to you.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Keeping your information secure")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          PayPoint takes its obligations to keep data secure seriously. It is\n          ISO 27001 accredited and a PCI compliant organisation for the\n          purpose of processing card payment data.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Governing Law")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          This Privacy Notice shall be governed by and construed in accordance\n          with English law and the parties hereby submit to the exclusive\n          jurisdiction of the English courts in respect of all matters arising\n          in connection herewith.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("Retention")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          Information we hold in relation to payments is retained for\n          statutory and regulatory purposes. Payment information may be\n          retained for periods of 3, 5 and as applicable 10 years or such\n          other period as required by law. Information relating to tax records\n          may be held for 7 years or such other period are required by law.\n          Certain payment information is held for 7 years or up to 10 years\n          post completion of the contract. Where we hold information on behalf\n          of a Client, the retention period is as specified by the Client. We\n          can provide more information on retention periods for specific types\n          of information if you email\n          "
                  ),
                  _c("a", { attrs: { href: "mailto:privacy@paypoint.com" } }, [
                    _vm._v("privacy@paypoint.com"),
                  ]),
                  _vm._v(
                    ". Our\n          retention policy is updated from time to time to reflect changes in\n          our obligations and legal duties.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("How to contact us")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you want to request information about our privacy policies or a\n          complaint you can e-mail us at\n          "
                  ),
                  _c("a", { attrs: { href: "mailto:privacy@paypoint.com" } }, [
                    _vm._v("privacy@paypoint.com"),
                  ]),
                  _vm._v(" or\n          write to us at:\n        "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("\n          Data Protection Officer "),
                  _c("br"),
                  _vm._v("PayPoint Group "),
                  _c("br"),
                  _vm._v("1 The Boulevard\n          "),
                  _c("br"),
                  _vm._v("Shire Park "),
                  _c("br"),
                  _vm._v("Welwyn Garden City "),
                  _c("br"),
                  _vm._v("Hertfordshire\n          "),
                  _c("br"),
                  _vm._v("AL7 1EL\n        "),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          If you are not happy with our response to any query or wish to\n          complain you may also contact the Information Commissioner’s Office\n          via\n          "
                  ),
                  _c("a", { attrs: { href: "https://ico.org.uk/concerns/" } }, [
                    _vm._v("https://ico.org.uk/concerns/"),
                  ]),
                  _vm._v(
                    "\n          or by using the contact details at\n          "
                  ),
                  _c(
                    "a",
                    {
                      attrs: { href: "https://ico.org.uk/global/contact-us/" },
                    },
                    [_vm._v("https://ico.org.uk/global/contact-us/")]
                  ),
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v("Changes and Updates")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          We may update this Privacy Statement from time to time and in\n          particular as the legal environment in relation to your information\n          changes.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "This Privacy Statement was last updated on 20 July 2021"
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }